export default {"src":"/_next/static/media/icon_search.a3453e1f.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};